import { DateTime } from "luxon";

export const SHOW_INVOICES_FILTER = {
  Dashboard: true,
  Invoices: false,
  Payables: false,
  Receivables: false,
};


// Invoice states
export const RECEIVABLES = "receivables";
export const PAYABLES = "payables";
export const ALL_INVOICES = "allInvoices";

export const CURRENCIES_FILTER = [
  {
    displayTitle:"All",
    value: null,
  },
  {
    displayTitle: "AED",
    value: "AED",
  },
  {
    displayTitle: "USD",
    value: "USD",
  },
];

// Invoice constants
export const RECEIVABLE = "Receivable";
export const PAYABLE = "Payable";


// Transactions states
export const CREDIT = "credit";
export const DEBIT = "debit";
export const ALL_TRANSACTIONS = "allTransactions";

// Pagination constants
export const PAGE_SIZE = 20;

export const INVOICE_STATES = Object.freeze({
  DRAFT: 'DRAFT',
  COOLING: "COOLING",
  PAID: 'PAID',
  DUE: 'DUE',
  OVERDUE: 'OVERDUE',
  SETTLED: 'SETTLED',
  REJECTED: 'REJECTED',
  VOIDED: 'VOIDED',
});

export const LOG_ENTITIES = Object.freeze({
  INVOICE: 'Invoice',
  BANK: 'Bank',
  BANK_ACCOUNT: 'Bank Account',
  PAYMENT: 'Payment',
  PAYMENT_METHOD: 'Payment Method',
  TRANSACTION: 'Transaction',
});

export const ANALYTICS_DATES = Object.freeze({
  TODAY: "Today",
  TODAY_VALUE: "today",

  LAST_WEEK: "Last Week",
  LAST_WEEK_VALUE: "last_week",

  NEXT_WEEK: "Next Week",
  NEXT_WEEK_VALUE: "next_week",

  LAST_MONTH: "Last Month",
  LAST_MONTH_VALUE: "last_month",
  
  NEXT_MONTH: "Next Month",
  NEXT_MONTH_VALUE: "next_month",

  LAST_7_DAYS: "Last 7 Days",
  LAST_7_DAYS_VALUE: "last_7_days",

  NEXT_7_DAYS: "Next 7 Days",
  Next_7_DAYS_VALUE: "next_7_days",

  LAST_30_DAYS: "Last 30 Days",
  LAST_30_DAYS_VALUE: "last_30_days",

  NEXT_30_DAYS: "Next 30 Days",
  NEXT_30_DAYS_VALUE: "next_30_days",

  LAST_THREE_MONTHS: "Last Three Months",
  LAST_THREE_MONTHS_VALUE: "last_three_months",

  THIS_YEAR: "This Year",
  THIS_YEAR_VALUE: "this_year",
});

export const QUERY_PARAMETERS = Object.freeze({
  PAGE_NO: 'page',
  PAGE_SIZE: 'page_size',
  START_TIME: 'due_start',
  END_TIME: 'due_end',
  ISSUE_START_TIME: 'issue_start_time',
  ISSUE_END_TIME: 'issue_end_time',
  SORT: "sort",
  SEARCH: 'search',
  ID: "id",
  EMAIL_CONFIG:"email_config",
  START_DATE: 'start_date',
  END_DATE: 'end_date',
  PERIOD: 'period',
  CHART:'chart',
  AMOUNT:'isAmount',
  CUMMULATIVE:'isCumulative',
  PERCENT:'isPercent',
  // Invoice Params
  TYPE: 'type',
  STATUS: 'status',
  CURRENCY: "currency",

  // Activity Logs Params
  ENTITY: 'entity_type',

  // Transactions Params
  TRANSACTION_TYPE: 'transaction_type'
});


export const PERMISSIONS = {
  ANALYTICS_ALL: "analytics:all",
  FINANCING_ALL: "financing:all",
  CHATBOT_ALL: "chatbot:all",
  IS_SUPERUSER: "is_superuser",
};

export const PAYMENT_TERMS = {
  NOW: 'NOW',
  NET_30: 'NET 30',
  NET_60: 'NET 60',
  CUSTOM: 'CUSTOM',
};

const today = DateTime.now();
const todayStart = today.startOf('day');

export const DUE_DATE_LABELS = [
  {
    label: PAYMENT_TERMS.NOW,
    dateFn: (date=today) => {
      if (date instanceof Date) {
        date = DateTime.fromJSDate(date)
      }
      return date.endOf('day');
    }, 
  },
  {
    label: PAYMENT_TERMS.NET_30,
    dateFn: (date=today) => {
      if (date instanceof Date) {
       date = DateTime.fromJSDate(date);
      }
      return date.plus({days: 40}).endOf('day');
    },
  },
  {
    label: PAYMENT_TERMS.NET_60,
    dateFn: (date=today) => {
      if (date instanceof Date) {
        date = DateTime.fromJSDate(date);
      }
      return date.plus({days: 60}).endOf('day');
    },
  }
];

export const ISSUE_DATE_LABELS = [
  {
    label: "TODAY",
    dateFn: () => todayStart
  },
  {
    label: "YESTERDAY",
    dateFn: () => todayStart.minus({days: 1}),
  },
  {
    label: "TOMORROW",
    dateFn: () => todayStart.plus({days: 1}),
  }
];

export const EDIT_INVOICE_ISSUE_DATE_LABELS = [
  {
    label: "CURRENT DAY",
    dateFn: (date) => {
      if (date instanceof Date) {
        date = DateTime.fromJSDate(date);
      }
      return date.startOf('day');
    }
  },
  {
    label: "ONE DAY AGO",
    dateFn: (date) => {
      if (date instanceof Date) {
        date = DateTime.fromJSDate(date);
      }
      const val = date.minus({days:1}).startOf('day')
      console.log(val.toISO());
      return val;
    },
  },
  {
    label: "ONE DAY LATER",
    dateFn: (date) => {
      if (date instanceof Date) {
        date = DateTime.fromJSDate(date);
      }
      return date.plus({days: 1}).startOf('day');
    },
  }
];

export const BUSINESS_ADMIN_NAME = "Admin";

export const PAYMENT_FLAVOR_TEXTS = [
  "Connecting to your bank for the payment request...",
  "Please wait while we process your payment request...",
  "Hang on, this could take a while...",
];

export const NOT_SUPPORTED_BANKS = [
  "Select your bank",
  "Abu Dhabi Islamic Bank",
  "Ajman Bank",
  "Al Hilal Bank",
  "Al Maryah Community Bank",
  "Al Masraf Arab Bank for Investment & Foreign Trade",
  "Bank of Sharjah",
  "Commercial Bank International",
  "Dubai Bank",
  "Dubai Finance Bank",
  "Dubai Islamic Bank",
  "Emirates Investment Bank",
  "Invest Bank",
  "National Bank of Fujairah",
  "National Bank of Umm Al-Quwain",
  "Noor Bank",
  "Sharjah Islamic Bank",
  "United Arab Bank",
  "Wio Bank",
  "Other"
];

export const ERROR_WORDS = [
  "error",
  "null",
  "undefined",
  "unexpected",
  "uncaught",
  "invalid",
  "doesn’t",
  "cannot",
  "expected",
  "missing",
  "unsupported",
];

export const SECTIONS = {
  Payment: {
    allow_advance_payments: {
      field: "allow_advance_payments",
      displayValue: "Allow Advance Payments",
      type: "checkbox",
    },
    flag_batch_payments: {
      field: "flag_batch_payments",
      displayValue: "Allow Batch Payments",
      type: "checkbox",
    },
    partial_payments: {
      field: "partial_payments",
      displayValue: "Allow Partial Payments",
      type: "checkbox",
    },
    enable_wire_transfer: {
      field: "enable_wire_transfer",
      displayValue: "Enable Wire Transfer",
      type: "checkbox",
    },
    enable_bank_payments: {
      field: "enable_bank_payments",
      displayValue: "Enable bank payments",
      type: "checkbox",
    },
    partial_payments_on_banks: {
      field: "partial_payments_on_banks",
      displayValue: "Partial pay with bank",
      type: "checkbox",
    },
    partial_payments_on_cards: {
      field: "partial_payments_on_cards",
      displayValue: "Partial pay with cards",
      type: "checkbox",
    },
    flag_payer_credit_management: {
      field: "flag_payer_credit_management",
      displayValue: "Payer Credit Management",
      type: "checkbox",
    },
    apply_convenience_fee: {
      field: "apply_convenience_fee",
      displayValue: "Apply Convenience Fee",
      type: "checkbox",
    },
    flag_payment_receipt: {
      field: "flag_payment_receipt",
      displayValue: "Generate Payment Receipt",
      type: "checkbox",
    },
    flag_payment_statement: {
      field: "flag_payment_statement",
      displayValue: "Generate Payment Statement",
      type: "checkbox",
    },
    has_completed_first_payment: {
      field: "has_completed_first_payment",
      displayValue: "Completed First Payment",
      type: "checkbox",
    },
    flag_pay_in: {
      field: "flag_pay_in",
      displayValue: "Pay-ins",
      type: "checkbox",
    },
    flag_pay_out: {
      field: "flag_pay_out",
      displayValue: "Pay-outs",
      type: "checkbox",
    },
  },
  Integrations: {
      erp_integrated: {
      field: "erp_integrated",
      displayValue : "Erp Integrated",
      type: "text",
      editable: false,
    },
    allow_integrations: {
      field: "allow_integrations",
      displayValue: "Allow Integrations",
      type: "checkbox",
    },
    allow_account_integrations: {
      field: "allow_account_integrations",
      displayValue: "Allow Account Integrations",
      type: "checkbox",
    },
    // xero_integrated: {
    //   field: "xero_integrated",
    //   displayValue: "Xero Integrated",
    //   type: "checkbox",
    // },
    // zoho_integrated: {
    //   field: "zoho_integrated",
    //   displayValue: "Zoho Integrated",
    //   type: "checkbox",
    // },
    flag_api_access: {
      field: "flag_api_access",
      displayValue: "API Access",
      type: "checkbox",
    },
    flag_ecommerce_integration: {
      field: "flag_ecommerce_integration",
      displayValue: "Allow Ecommerce Integration",
      type: "checkbox",
    },
    flag_salesforce_integration: {
      field: "flag_salesforce_integration",
      displayValue: "Allow Salesforce Integration",
      type: "checkbox",
    },
    flag_allow_aps: {
      field: "flag_allow_aps",
      displayValue: "Allow APS",
      type: "checkbox",
    },
    flag_allow_checkout: {
      field: "flag_allow_checkout",
      displayValue: "Allow Checkout",
      type: "checkbox",
    },
    webhook_url: {
      field: "webhook_url",
      displayValue: "Webhook URL",
      type: "text",
    },
    redirect_url: {
      field: "redirect_url",
      displayValue: "Redirect URL",
      type: "text",
    },
    tncs_url: {
      field: "tncs_url",
      displayValue: "TNCs URL",
      type: "text",
    },
  },
  Profile: {
    display_name: {
      field: "display_name",
      displayValue: "Display Name",
      type: "text",
    },
    address: {
      field: "address",
      displayValue: "Address",
      type: "text",
    },
    is_merchant: {
      field: "is_merchant",
      displayValue: "Merchant",
      type: "checkbox",
    },
    show_privacy_policy: {
      field: "show_privacy_policy",
      displayValue: "Show Privacy Policy",
      type: "checkbox",
    },
    bypass_buyer_signup: {
      field: "bypass_buyer_signup",
      displayValue: "Bypass Buyer Signup",
      type: "checkbox",
    },
    send_monthly_newsletter: {
      field: "send_monthly_newsletter",
      displayValue: "Send Monthly NewsLetter",
      type: "checkbox",
    },
    flag_advanced_analytics: {
      field: "flag_advanced_analytics",
      displayValue: "Advance Analytics",
      type: "checkbox",
    },
    flag_email_branding: {
      field: "flag_email_branding",
      displayValue: "Email Branding",
      type: "checkbox",
    },
    flag_branded_payer_portal: {
      field: "flag_branded_payer_portal",
      displayValue: "Branded Payer Portal",
      type: "checkbox",
    },
    flag_sandbox_access: {
      field: "flag_sandbox_access",
      displayValue: "Allow Sandbox Access",
      type: "checkbox",
    },
    has_set_flags: {
      field: "has_set_flags",
      displayValue: "Has Set Flags",
      type: "checkbox",
    },
    is_test: {
      field: "is_test",
      displayValue: "Is Test",
      type: "checkbox",
    },
  },
  Invoice: {
    flag_bulk_invoice_upload: {
      field: "flag_bulk_invoice_upload",
      displayValue: "Allow Bulk Invoice Upload",
      type: "checkbox",
    },
    payables_count: {
      field: "payables_count",
      displayValue: "Payables Count",
      type: "checkbox",
    },
    receivables_count: {
      field: "receivables_count",
      displayValue: "Receivables Count",
      type: "checkbox",
    },
    flag_recv_in: {
      field: "flag_recv_in",
      displayValue: "Enable Incoming ERP Receivables",
      type: "checkbox",
    },
    flag_recv_out: {
      field: "flag_recv_out",
      displayValue: "Enable Outgoing ERP Receivables",
      type: "checkbox",
    },
    flag_allow_erp_attachments_pull: {
      field: "flag_allow_erp_attachments_pull",
      displayValue: "Allow ERP Attachments Pull",
      type: "checkbox",
    },
  },
  Email: {
    autosend_invoice_mails: {
      field: "autosend_invoice_mails",
      displayValue: "Autosend Invoice Emails",
      type: "checkbox",
    },
    autosend_payment_mails: {
      field: "autosend_payment_mails",
      displayValue: "Autosend Payment Emails",
      type: "checkbox",
    },
    autosend_reminder_mails: {
      field: "autosend_reminder_mails",
      displayValue: "Autosend Reminder Emails",
      type: "checkbox",
    },
    erp_payment_buyer_mails: {
      field: "erp_payment_buyer_mails",
      displayValue: "ERP Payment Buyer Emails",
      type: "checkbox",
    },
    erp_payment_seller_mails: {
      field: "erp_payment_seller_mails",
      displayValue: "ERP Payment Seller Emails",
      type: "checkbox",
    },
    enable_email_cc: {
      field: "enable_email_cc",
      displayValue: "Enable Email CC",
      type: "checkbox",
    },
    email_sender_name: {
      field: "email_sender_name",
      displayValue: "Email Sender Name",
      type: "text",
    },
  },
  Billing: {
    is_billing_enabled: {
      field: "is_billing_enabled",
      displayValue: "Is Billing Enabled",
      type: "checkbox",
    },
    billing_contact_name: {
      field: "billing_contact_name",
      displayValue: "Billing Contact Name",
      type: "text",
    },
    billing_contact_email: {
      field: "billing_contact_email",
      displayValue: "Billing Contact Email",
      type: "text",
    },
    billing_contact_phone: {
      field: "billing_contact_phone",
      displayValue: "Billing Contact Phone",
      type: "text",
    },
    tax_reference_number: {
      field: "tax_reference_number",
      displayValue: "Tax Reference Number",
      type: "text",
    },
  },
  Payment_Integration: {
    integration: {
      field: "integration",
      displayValue: "Integration",
      type: "text",
    },
    can_save_cards: {
      field: "can_save_cards",
      displayValue: "Can Save Cards",
      type: "checkbox",
    },
    is_active: {
      field: "is_active",
      displayValue: "Is Active",
      type: "checkbox",
    },
    is_iframe: {
      field: "is_iframe",
      displayValue: "Is Iframe",
      type: "checkbox",
    },
    is_sandbox: {
      field: "is_sandbox",
      displayValue: "Is Sandbox",
      type: "checkbox",
    },
    card_schemes: {
      field: "card_schemes",
      displayValue: "Card Schemes",
      type: "text",
    },
    payment_methods: {
      field: "payment_methods",
      displayValue: "Payment Methods",
      type: "text",
    },
  }
};

export const HEADER_SECTION = {
  companyDetails: {
    name: { field: 'name', displayValue: 'Name', },
    country: { field: 'country', displayValue: 'Country', },
    base_currency: { field: 'base_currency', displayValue: 'Currency', },
  },
  adminDetails: {
    first_name: { field: 'first_name', displayValue: 'Admin Name', },
    email: { field: 'email', displayValue: 'Admin Email', },
  },
}


export const MAIN_SECTORS = [
  'Agriculture, Forestry, Fishing and Hunting',
  'Mining, Quarrying, and Oil and Gas Extraction',
  'Utilities',
  'Construction',
  'Manufacturing',
  'Wholesale Trade',
  'Retail Trade',
  'Transportation and Warehousing',
  'Information',
  'Finance and Insurance',
  'Real Estate and Rental and Leasing',
  'Professional, Scientific, and Technical Services',
  'Management of Companies and Enterprises',
  'Administrative and Support and Waste Management and Remediation Services',
  'Educational Services',
  'Health Care and Social Assistance',
  'Arts, Entertainment, and Recreation',
  'Accommodation and Food Services',
  'Other Services (except Public Administration)'
  ]


export const SECTOR_TO_SUB_SECTORS = {
    "Agriculture, Forestry, Fishing and Hunting": [
        "Agriculture & Forestry/Wildlife Extermination/Pest Control",
        "Farming (Animal Production)",
        "Farming (Crop Production)",
        "Fishing/Hunting",
        "Landscape Services",
        "Lawn care Services",
        "Other (Agriculture & Forestry/Wildlife)"
    ],
    "Mining, Quarrying, and Oil and Gas Extraction": [
        "Oil & Gas Distribution",
        "Oil & Gas Extraction/Production",
        "Coal Mining",
        "Other Mining (metallic & non-metallic etc.)"
    ],
    "Utilities": [
        "Environmental Health",
        "Water, Sewage and Other Systems",
        "Electric Power Generation, Transmission and Distribution",
        "Natural Gas Distribution"
    ],
    "Construction": [
        "Architect",
        "Building Construction",
        "Building Inspection",
        "Building Equipment Contractors",
        "Concrete Manufacturing",
        "Contractor",
        "Engineering/Drafting",
        "Equipment Rental",
        "Plumbing",
        "Remodeling",
        "Repair/Maintenance",
        "Heavy and Civil Engineering Construction",
        "Other (Construction/Utilities/Contracting)"
    ],
    "Manufacturing": [
        "Alcoholic Beverage Manufacturing",
        "Food/Beverage/Bakery Manufacturing",
        "Animal Food Manufacturing",
        "Grain / Flour and Oilseed Milling",
        "Dairy Product Manufacturing",
        "Specialty Food (Fruit/Vegetables)",
        "Specialty Food (Meat)",
        "Specialty Food (Seafood)",
        "Specialty Food (Coffee)",
        "Tobacco Product Manufacturing",
        "Automotive Part Sales",
        "Concrete Manufacturing",
        "Electrical Equipment, Appliance, and Component Manufacturing",
        "Furniture and Home Furnishings Stores",
        "Machinery Manufacturing",
        "Glass and Glass Product Manufacturing",
        "Cement and Concrete Product Manufacturing",
        "Other (Manufacturing)",
        "Pharmaceutical Manufacturing",
        "Plastics, Paper & Rubber Products Manufacturing",
        "Printing and Publishing",
        "Textile and Apparel Manufacturing",
        "Wood Product Manufacturing"
    ],
    "Wholesale Trade": [
        "Wholesale Drug Distribution",
        "Motor Vehicle and Motor Vehicle Parts and Supplies Merchant Wholesalers",
        "Furniture and Home Furnishing Merchant Wholesalers",
        "Lumber and Other Construction Materials Merchant Wholesalers",
        "Professional and Commercial Equipment and Supplies Merchant Wholesalers",
        "Metal and Mineral (except Petroleum) Merchant Wholesalers",
        "Household Appliances and Electrical and Electronic Goods Merchant Wholesalers",
        "Hardware, and Plumbing and Heating Equipment and Supplies Merchant Wholesalers",
        "Machinery, Equipment, and Supplies Merchant Wholesalers",
        "Miscellaneous Durable Goods Merchant Wholesalers",
        "Merchant Wholesalers, Nondurable Goods",
        "Paper and Paper Product Merchant Wholesalers",
        "Drugs and Druggists' Sundries Merchant Wholesalers",
        "Apparel, Piece Goods, and Notions Merchant Wholesalers",
        "Grocery and Related Product Merchant Wholesalers",
        "Farm Product Raw Material Merchant Wholesalers",
        "Chemical and Allied Products Merchant Wholesalers",
        "Petroleum and Petroleum Products Merchant Wholesalers",
        "Beer, Wine, and Distilled Alcoholic Beverage Merchant Wholesalers",
        "Wholesale Trade Agents and Brokers",
        "Wholesale FMCG Distribution"
    ],
    "Retail Trade": [
        "Alcohol/Tobacco Sales",
        "Specialty Food (Fruit/Vegetables)",
        "Specialty Food (Meat)",
        "Specialty Food (Seafood)",
        "Automobile Dealers (new & used cars)",
        "Automotive Parts, Accessories, and Tire Retailers",
        "Building Material and Supplies Dealers",
        "Lawn and Garden Equipment and Supplies Retailers",
        "Food and Beverage Retailers",
        "Furniture and Home Furnishings Retailers",
        "Electronics and Appliance Retailers",
        "Department Stores",
        "Warehouse Clubs, Supercenters, and Other General Merchandise Retailers",
        "Health and Personal Care Retailers",
        "Gasoline Stations",
        "Fuel Dealers",
        "Clothing and Clothing Accessories Retailers",
        "Shoe Retailers",
        "Jewelry, Luggage, and Leather Goods Retailers",
        "Sporting Goods, Hobby, and Musical Instrument Retailers",
        "Book Retailers and News Dealers",
        "Office Supplies, Stationery, and Gift Retailers",
        "Other (Retail Trade)"
    ],
    "Transportation and Warehousing": [
        "Air Transportation",
        "Boat Services",
        "Limousine Services",
        "Taxi Services",
        "Towing",
        "Truck Transportation (Fuel)",
        "Truck Transportation (Non Fuel)",
        "Warehousing and Storage",
        "General Freight Trucking and Couriers and Express Delivery Services",
        "Digital Freight Marketplace"
    ],
    "Information": [
        "Broadcasting (except Internet)",
        "Data Processing, Hosting, and Related Services",
        "Other Information Services",
        "Publishing Industries (except Internet)",
        "Telecommunications"
    ],
    "Finance and Insurance": [
        "Accountant",
        "Auditing",
        "Bank/Credit Union",
        "Bookkeeping",
        "Cash Advances",
        "Collection Agency",
        "Insurance",
        "Investor",
        "Pawn Brokers",
        "Tax Preparation"
    ],
    "Real Estate and Rental and Leasing": [
        "Real Estate Broker/Agent",
        "Property Management",
        "Real Estate School",
        "Rental and Leasing Services",
        "Warehouse/Storage",
        "Manufactured Housing"
    ],
    "Professional, Scientific, and Technical Services": [
        "Business & Information Consultant",
        "Employment Office",
        "Fundraisers",
        "Marketing/Advertising",
        "Publishing Services",
        "Record Business",
        "Technology Services",
        "Telemarketing",
        "Video Production",
        "Architectural Services",
        "Engineering Services",
        "Legal Services",
        "Management Consulting",
        "Other Professional, Scientific, and Technical Services"
    ],
    "Management of Companies and Enterprises": [
        "Management of Companies and Enterprises"
    ],
    "Administrative and Support and Waste Management and Remediation Services": [
        "Employment Office",
        "Fundraisers",
        "Going out of Business Sales",
        "Other (Business & Information)",
        "Waste Management and Remediation Services"
    ],
    "Educational Services": [
        "Child Care Services",
        "College/Universities",
        "Cosmetology School",
        "Elementary & Secondary Education",
        "GED Certification",
        "Other (Education)",
        "Private School",
        "Real Estate School",
        "Technical School",
        "Trade School",
        "Tutoring Services",
        "Vocational School"
    ],
    "Health Care and Social Assistance": [
        "Acupuncturist",
        "Hospital",
        "Pharmacy",
        "Athletic Trainer",
        "Child/Youth Services",
        "Dentistry",
        "Electrolysis",
        "Emergency Medical Services",
        "Emergency Medical Transportation",
        "Hearing Aid Dealers",
        "Home Health Services",
        "Massage Therapy",
        "Medical Office",
        "Mental Health Services",
        "Non-Emergency Medical Transportation",
        "Optometry",
        "Other (Health Services)",
        "Physical Therapy",
        "Physicians Office",
        "Radiology",
        "Residential Care Facility",
        "Speech/Occupational Therapy",
        "Veterinary Medicine",
        "Wholesale Drug Distribution"
    ],
    "Arts, Entertainment, and Recreation": [
        "Promoters of Performing Arts, Sports, and Similar Events",
        "Boxing/Wrestling",
        "Casino/Video Gaming",
        "Spectator Sports",
        "Sports Agent",
        "Entertainment/Party Rentals",
        "Event Planning",
        "Performing Arts, Spectator Sports, and Related Industries",
        "Other Arts, Entertainment, and Recreation"
    ],
    "Accommodation and Food Services": [
        "Traveler Accommodation",
        "Mobile Food Services",
        "Restaurant/Bar",
        "Truck Stop",
        "Vending Machine",
        "Travel & Tourism"
    ],
    "Other Services (except Public Administration)": [
        "Personal and Household Goods Repair and Maintenance",
        "Commercial and Industrial Machinery and Equipment (except Automotive and Electronic) Repair and Maintenance",
        "Electronic and Precision Equipment Repair and Maintenance",
        "Automotive Repair and Maintenance",
        "Personal Care Services (Barber shops, Beauty Saloon etc.)",
        "Business, Professional, Labor, Political, and Similar Organizations",
        "Drycleaning and Laundry Services",
        "Other Services (except Public Administration)",
        "Personal Assistant",
        "Photography"
    ]
}

